import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef, editTechTalkRouteRef } from './routes';
import {
  contributeApiRef,
  ContributeClient,
  techTalkApiRef,
  TechTalkClient,
} from './api';

export const techTalkPlugin = createPlugin({
  id: 'tech-talk',
  apis: [
    createApiFactory({
      api: techTalkApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TechTalkClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: contributeApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ContributeClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
    edit: editTechTalkRouteRef,
  },
});

// Link-first /contribuer page: creates a tech talk, or opens a catalog merge
// request through the add-to-catalog template for a forge link
export const ContributePage = techTalkPlugin.provide(
  createRoutableExtension({
    name: 'ContributePage',
    component: () =>
      import('./components/ContributePage').then(m => m.ContributePage),
    mountPoint: rootRouteRef,
  }),
);

export const EditTechTalkPage = techTalkPlugin.provide(
  createRoutableExtension({
    name: 'EditTechTalkPage',
    component: () =>
      import('./components/EditTechTalkPage').then(m => m.EditTechTalkPage),
    mountPoint: editTechTalkRouteRef,
  }),
);

export const EntityTechTalkActionsCard = techTalkPlugin.provide(
  createComponentExtension({
    name: 'EntityTechTalkActionsCard',
    component: {
      lazy: () =>
        import('./components/EntityTechTalkActionsCard').then(
          m => m.EntityTechTalkActionsCard,
        ),
    },
  }),
);
